import React from "react";
import TextInput from "@/Components/TextInput";
import useInertiaField from "@/Hooks/useInertiaField";

/**
 * Адаптер-компонент для работы с Inertia
 * Если вам не нужно работать с помошником-формой от Inertia, пожалуйста используйте <TextInput /> напрямую
 * @param {string} name - имя поля
 * @param {boolean} disabled - имя поля
 * @param {object} form - объект из useForm (Inertia)
 * @param {object} rest - остальные пропсы
 * @returns {JSX.Element}
 * @constructor
 */
const InertiaTextInput = ({name, disabled, form, ...rest}) => {
    if (!name || !form) {
        // MODE - Это встроенная переменная Vite, она доступна всегда ("development" или "production")
        if (import.meta.env.MODE !== 'production') {
            console.warn(
                `<InertiaTextInput /> requires both "name" and "form" props. Received:`,
                {name, form}
            );
        }
        return null;
    }

    const onChange = disabled ? () => {
    } : useInertiaField(name, form);

    return (
        <TextInput
            name={name}
            value={form.data[name]}
            message={form.errors[name]}
            onChange={onChange}
            disabled={disabled}
            {...rest}
        />
    );
}

export default InertiaTextInput;
